/**
 * Rang ochiqmi (yorug'ligi bo'yicha) — ochiq fonda qora, to'q fonda oq matn uchun.
 */
const isLightColor = (hex) => {
  if (!hex || !hex.startsWith('#')) return false;
  const h = hex.replace('#', '');
  const f =
    h.length === 3
      ? h
          .split('')
          .map((c) => c + c)
          .join('')
      : h;
  const r = parseInt(f.substr(0, 2), 16);
  const g = parseInt(f.substr(2, 2), 16);
  const b = parseInt(f.substr(4, 2), 16);
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.7;
};

export default isLightColor;
